// src/pages/volunteering/formPreview.js
import React from "react";

const FormPreview = ({ fields }) => {
  if (fields.length === 0) {
    return <p className="vfl-empty-fields">No fields to preview yet.</p>;
  }

  return (
    <div className="vfl-form-preview">
      {fields.map((field, index) => (
        <div key={index} className="vfl-preview-field">
          <label className="vfl-preview-label">
            {field.label}
            {field.required && <span className="vfl-preview-required"> *</span>}
          </label>

          {field.type === "text" && <input className="vfl-preview-input" type="text" disabled placeholder="Text answer" />}
          {field.type === "number" && <input className="vfl-preview-input" type="number" disabled placeholder="Number" />}
          {field.type === "email" && <input className="vfl-preview-input" type="email" disabled placeholder="email@example.com" />}
          {field.type === "phone" && <input className="vfl-preview-input" type="tel" disabled placeholder="Phone number" />}
          {field.type === "date" && <input className="vfl-preview-input" type="date" disabled />}
          {field.type === "textarea" && <textarea className="vfl-preview-input vfl-preview-textarea" disabled placeholder="Long answer" />}
          {field.type === "checkbox" && (
            <div className="vfl-preview-checkbox-row">
              <input type="checkbox" disabled />
              <span className="vfl-preview-checkbox-label">Check this box</span>
            </div>
          )}
          {field.type === "file" && <input className="vfl-preview-input" type="file" disabled />}
          {field.type === "dropdown" && (
            <select className="vfl-preview-input" disabled>
              <option>Select an option</option>
              {field.options?.map((opt, i) => (
                <option key={i}>{opt}</option>
              ))}
            </select>
          )}
        </div>
      ))}
    </div>
  );
};

export default FormPreview;
